module.exports = __webpack_public_path__ + "static/media/gi.0de30a2e.svg";